// request
export const START_REQUEST = 'START_REQUEST';
export const FINISH_REQUEST = 'FINISH_REQUEST';

/** Begin TravelArea **/  //2020/12/09 Wen modify
// mutations
export const SET_NOT_ABROAD = 'SET_NOT_ABROAD';
export const SET_ABROAD = 'SET_ABROAD';

// actions
export const  GET_TRAVELAREA_ACTION = 'GET_TRAVELAREA_ACTION';

// update 
export const UPDATE_TRAVELAREA = 'UPDATE_TRAVELAREA';
/** End TravelArea **/

/** Begin AccidentArea **/  //2020/12/09 Wen modify
// mutations
export const SET_NOT_ACCIDENTABROAD = 'SET_NOT_ACCIDENTABROAD';
export const SET_ACCIDENTABROAD = 'SET_ACCIDENTABROAD';

// actions
export const  GET_ACCIDENTAREA_ACTION = 'GET_ACCIDENTAREA_ACTION';

// update 
export const UPDATE_ACCIDENTAREA = 'UPDATE_ACCIDENTAREA';
/** End ACCIDENTArea **/


/** Begin Index Banner **/
// mutations
export const SET_INDEX_BANNER = 'SET_INDEX_BANNER';

// actions
//export const GET_INDEX_BANNER_ACTION = 'SET_INDEX_BANNER_ACTION';
export const  GET_INDEX_BANNER_ACTION = 'GET_INDEX_BANNER_ACTION';

// update 
export const UPDATE_INDEX_BANNER_ACTION = 'UPDATE_INDEX_BANNER_ACTION';

/** End Index Banner **/

/** Begin vehicleOption **/
// mutations
export const SET_CAR_OPTION_BRAND = 'SET_CAR_OPTION_BRAND';
export const SET_CAR_OPTION_CARSTYLE = 'SET_CAR_OPTION_CARSTYLE';
export const SET_MOTOR_OPTION_BRAND = 'SET_MOTOR_OPTION_BRAND';
export const SET_MOTOR_OPTION_CARSTYLE = 'SET_MOTOR_OPTION_CARSTYLE';
export const SET_CAR_OPTION_CARTYPE = 'SET_CAR_OPTION_CARTYPE';
export const SET_MOTOR_OPTION_CARTYPE = 'SET_MOTOR_OPTION_CARTYPE';

// actions
export const GET_BRAND_OPTION_ACTION = 'SET_BRAND_OPTION_ACTION';
export const GET_CARSTYLE_OPTION_ACTION = 'SET_CARSTYLE_OPTION_ACTION';
export const GET_CARTYPE_OPTION_ACTION = 'GET_CARTYPE_OPTION_ACTION';
// update 
export const UPDATE_CAR_OPTION_ACTION = 'UPDATE_CAR_OPTION_ACTION';
export const UPDATE_MOTOR_OPTION_ACTION = 'UPDATE_MOTOR_OPTION_ACTION';

/** End vehicleOption **/

